<app-sprintpay-header
    [showFacilityInformation]="showFacilityInformation"
    [administrativeLoginURL]="administrativeLoginURL"
    [homeURL]="homeURL"
    [cartDisallowedRoutes]="cartDisallowedRoutes"
>
    <ng-content></ng-content>
</app-sprintpay-header>
